export default __webpack_public_path__ + "static/media/mastercard.cb335e28.png";